import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useAssignSettingPersistQuickAddOnSearchTile } from "@faire/retailer-visitor-shared/settings/useSettingPersistQuickAddOnSearchTile";
import React from "react";

export const useAssignPersistQuickAddOnSearchTile = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const assignPersistQuickAdd = useAssignSettingPersistQuickAddOnSearchTile();
  React.useEffect(() => {
    if (isLoggedInRetailer) {
      assignPersistQuickAdd();
    }
  }, [isLoggedInRetailer, assignPersistQuickAdd]);
};
